// @ts-ignore
import zhCn from 'element-plus/dist/locale/zh-cn.mjs'
// @ts-ignore
import zhTw from 'element-plus/dist/locale/zh-tw.mjs'
// @ts-ignore
import en from 'element-plus/dist/locale/en.mjs'

export const languages = [
    {
        label: '简体中文',
        value: 'zhCn',
        components: zhCn
    },
    {
        label: '繁體中文',
        value: 'zhTw',
        components: zhTw
    },
    {
        label: 'English',
        value: 'en',
        components: en
    },
];

export default languages;
